import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { Transaction } from "@/lib/finance";
import { signedMoney } from "@/lib/format";

export function DeleteTransactionDialog({ tx, onCancel, onConfirm }: { tx: Transaction | null; onCancel: () => void; onConfirm: () => void }) {
  return (
    <AlertDialog open={!!tx} onOpenChange={(o: boolean) => !o && onCancel()}>
      <AlertDialogContent className="bg-white" data-testid="delete-tx-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>¿Borrar este movimiento?</AlertDialogTitle>
          <AlertDialogDescription>
            {tx ? `${tx.description} · ${signedMoney(tx.amount, tx.flow)}. ` : ""}Los saldos y totales se recalculan al instante.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-tx-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-[#B23A1E] hover:bg-[#9a3119]" data-testid="delete-tx-confirm">Borrar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
